import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const afWhitelistTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Media Gateway',
  key: 'mediaGateway',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['AFID', 'AFTYPE', 'AFPROTOCOL'],
          ['IPADDR', 'GRAYITEM'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        label: 'AF Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 256,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      AFTYPE: {
        label: 'AF Type',
        type: 'advancedSelect',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Select an AF type',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      AFPROTOCOL: {
        label: 'AF Protocol',
        type: 'select',
        readOnlyIfOneOption: true,
        initial: 'ANY',
        options: [
          {
            label: 'Any',
            value: 'ANY',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      IPADDR: {
        label: 'AF IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      GRAYITEM: {
        label: 'Gray List Item',
        type: 'checkbox',
        initial: false,
      }
    },
  },
};
